import { render, staticRenderFns } from "./BikyPlanSelector.vue?vue&type=template&id=66034974&scoped=true&"
import script from "./BikyPlanSelector.vue?vue&type=script&lang=ts&"
export * from "./BikyPlanSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BikyPlanSelector.vue?vue&type=style&index=0&id=66034974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66034974",
  null
  
)

export default component.exports